import { NgModule } from '@angular/core';
import { DigitalPaymentsModule } from '@spartacus/digital-payments';

@NgModule({
  declarations: [],
  imports: [DigitalPaymentsModule],
  providers: [],
})
export class DigitalPaymentsFeatureModule {}
